import React, { useState } from "react";
import { ButtonPrimary, ButtonTertiary } from "oolib/dist/v2/components/Buttons";
import { PopoverMenu } from "../../../PopoverMenu";
import { UI_BODY_SM } from "oolib";
import { AlertButton } from "../../../ReportSettingForm";
import { handleDeleteWidget } from "../../../../utils/handleDeleteWidget";
import { TOTAL_COLUMNS } from "../../../../constants"
import { actionButtonSize } from "../DataVizWidgetShell/styled";


const widgetSwitchMap = {
  "WidgetAISummary": "WidgetRichText",
}

export const WidgetActions = ({
  widgetConfig,
  isEditing,
  setUnderEditWidgetId,
  widgetIdx,
  config,
  setConfig,
  handleConvertToText
}) => {

const [showRemoveDropdown, setShowRemoveDropdown] = useState(false);

return(
    <div
      style={{ display: "flex", gap: "0.5rem" }}
      id={`widget-actions-${widgetConfig.id}`}
    >
      {widgetSwitchMap[widgetConfig?.comp] &&
        <ButtonTertiary
            icon="TextT"
            onClick={() =>
              handleConvertToText({ toWidgetType: widgetSwitchMap[widgetConfig.comp] })}
            style={{ height: actionButtonSize + "rem", width: actionButtonSize + "rem", margin: "-0.4rem 0" }}
          >
       </ButtonTertiary>}

      <PopoverMenu
        isOpen={showRemoveDropdown}
        onClose={() => setShowRemoveDropdown(false)}
        position="right"
        minWidth="200px"
        trigger={
          <ButtonTertiary
            icon="Trash"
            onClick={() => setShowRemoveDropdown(!showRemoveDropdown)}
            style={{ height: actionButtonSize + "rem", width: actionButtonSize + "rem", margin: "-0.4rem 0" }}
          >
            {/* Remove */}
          </ButtonTertiary>
        }
      >
        <div style={{ padding: "1.2rem", display: "flex", flexDirection: "column", gap: "0.8rem" }}>
          <UI_BODY_SM>
            Remove widget?
          </UI_BODY_SM>
          
          <AlertButton
            onClick={() => {
              handleDeleteWidget({
                widgetIndex: widgetIdx,
                config,
                setConfig,
                TOTAL_COLUMNS,
              });
              setShowRemoveDropdown(false);
            }}
          >
            Remove
          </AlertButton>
          
          <ButtonTertiary
            style={{ width: "100%" }}
            onClick={() => setShowRemoveDropdown(false)}
          >
            Cancel
          </ButtonTertiary>
        </div>
      </PopoverMenu>

      <ButtonPrimary
        icon={isEditing ? "Check" : "PencilSimple"}
        onClick={() =>
          isEditing
            ? setUnderEditWidgetId(undefined)
            : setUnderEditWidgetId(widgetConfig.id)
        }
        style={{ height: actionButtonSize + "rem", width: actionButtonSize + "rem", margin: "-0.4rem 0" }}
      />
    </div>
)
}